import { render, staticRenderFns } from "./PhoneOrEmailForm.vue?vue&type=template&id=33fe361d&scoped=true&"
import script from "./PhoneOrEmailForm.vue?vue&type=script&lang=js&"
export * from "./PhoneOrEmailForm.vue?vue&type=script&lang=js&"
import style0 from "./PhoneOrEmailForm.vue?vue&type=style&index=0&id=33fe361d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fe361d",
  null
  
)

export default component.exports